/**
 * Copyright (C) 2019 Egylis,
 * Siège social, 83 bis rue de l'Abbé Groult, 75015 Paris - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 */

/// <reference types="cordova-plugin-statusbar" />

// import 'hammerjs';
import {enableProdMode, LOCALE_ID} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';


function _window(): any {
    // return the global native browser window object
    return window;
}

if (environment.production) {
    enableProdMode();
}

const bootstrap = () => {
    platformBrowserDynamic([{provide: LOCALE_ID, useValue: 'fr-FR'}]).bootstrapModule(AppModule,
        {
            providers: [{provide: LOCALE_ID, useValue: 'fr-FR'}]
        }
    ).catch(err => console.error(err));

    // Init Cordova
    if (_window().cordova && StatusBar) {
        StatusBar.backgroundColorByHexString('#169DD9');
    }
    if (_window().cordova) {
        const platformId = _window().cordova.platformId;
        if (platformId) {
            document.body.classList.add('is-' + platformId);
        }
    } else {
        document.body.classList.add('is-web');
    }
};

// @ts-ignore
if (typeof window['cordova'] !== 'undefined') {
    document.addEventListener('deviceready', () => {
        bootstrap();
    }, false);
} else {
    bootstrap();
}
